export default __webpack_public_path__ + "static/media/spirit-swap.a02f272a.jpg";